module.exports = __webpack_public_path__ + "yt.svg?b8cf15a9e527f78ddf614ed4e04fcfa4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yt.svg
// module id = 76
// module chunks = 0